import React from "react";
import { ChromePicker } from "react-color";
const ColorPickerModal = ({ handleColorChange, color }) => {
  return (
    <>
      <ChromePicker color={color} onChange={handleColorChange} />
    </>
  );
};

export default ColorPickerModal;
